import React, { useEffect, useState, useMemo } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Table } from 'components/Table';
import Title from 'components/Title';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { RootState } from 'redux/store';
import { getReports } from 'redux/slices/Reports';
import { AgGrid, AgGridRef, ZColDef } from 'components/AgGrid/AgGrid';
import { Report } from 'models/dbModels/reports/Report';
import { GetRowIdParams, IRowNode } from 'ag-grid-enterprise';
import { Search, SearchState } from 'components/AgGrid/FilterComponents/Search';
import { getFeatureFlagValue, ZFlags } from 'components/ZFeatureFlag';

export function Reports() {
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
	const [loading, setLoading] = React.useState<boolean>(false);
	const gridRef = React.useRef<AgGridRef>(null);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const report = useAppSelector((state: RootState) => state.reports);
	const user = useAppSelector((state: RootState) => state.logedinUser);
	const global = useAppSelector((state: RootState) => state.global);
	const [reportsList, setReportsList] = useState<any[]>([]);
	const [keyword, setKeyword] = React.useState<string>("");
	const [selectedReport, setSelectedReport] = React.useState<Report | null>(null);

	useEffect(() => {
		dispatch(getReports({}))
		.then((reportData) => {
			if (getFeatureFlagValue(global.featureFlags, "ZFreedom.Reports.Experimental") === true){
				setReportsList(reportData.data);
				return;
			}
			
			setReportsList(reportData.data.filter(x => x.reportType != "SalesExperimental" && x.reportType != "StockExperimental"));});
	}, [])

	useEffect(() => {
		dispatch(getReports({}))
		.then((reportData) => {
			if (getFeatureFlagValue(global.featureFlags, "ZFreedom.Reports.Experimental") === true){
				setReportsList(reportData.data);
				return;
			}
			
			setReportsList(reportData.data.filter(x => x.reportType != "SalesExperimental" && x.reportType != "StockExperimental"));});
	}, [currentStoreGroupId])

	const columns = useMemo<ZColDef<Report>[]>(() => {
		return [
		{
			headerName: 'Report',
			field: 'name',
			sortable: true,
			pinned: true,
			checkboxSelection: false,
			cellRenderer: 'baseCellRenderer',
			cellRendererSelector: (params) => {
				return {
					component: 'baseCellRenderer',
					params: {
						children: <Link to={`/app/ReportViewer/${params.data.id}`} >{params.data.name}</Link>,
					}
				}
			},
			// cellRendererSelector: (params) => {
			// 	return {
			// 		component: 'baseCellRenderer',
			// 		params: {
			// 			decorators: [
			// 				{
			// 					decorator: <ZTooltip text={"This is a system report"}><ZIcon icon={ZIconType.System} size="18px" iconClassName={`me-1 ${params.data!.isSystem ? "visible" : "invisible"}`} /></ZTooltip>, 
			// 					position: "start",
			// 				},
							
			// 				// {
			// 				// 	decorator: <ZTooltip className="flex-shrink" text={"This is a system report"}><ZIcon icon={ZIconType.System} size="18px" iconClassName={`me-1`} /></ZTooltip>, 
			// 				// 	position: "end",
			// 				// 	showOnHover: true,
			// 				// 	containerClassName: "w-100 justify-content-end"
			// 				// }
			// 			]
			// 		}
			// 	}
			// }
		},
		{
			headerName: 'Description',
			field: 'description',
			onCellClicked(event) {
				if (event.colDef.checkboxSelection) {
					return;
				}
				navigate(`/app/ReportViewer/${event.data.id}`);
			},
		},
		// {
		// 	headerName: "",
		// 	pinned: "right",
		// 	cellRendererSelector: (params) => {
		// 		return {
		// 			component: 'baseCellRenderer',
		// 			params: {
		// 				decorator: <ZIcon icon={ZIconType.Edit} size="18px" />,
		// 				decoratorPosition: "end"
		// 			}
		// 		}
		// 	}
		// }
	]}, []);

	return (
		<>
			<Title pageTitle="Store Reports" />
			<Card>
				<Card.Body>
					<Row className="mb-1">
						<Col md={8} xxl={5} className="mt-1">
							<Search hideContains totalRows={report.totalRows} onSearch={(state) => {
								setKeyword(state.keyword ?? "");
							}} />
							
						</Col>
						<Col className="d-inline-flex gap-2 justify-content-end mt-1" md={4}>
							{/* <ZTooltip text="Add">
								<ZButton
                                	className="btn-icon custom-btn-icon" 
									icon={ZIconType.Add} 
									size="sm"
									onClick={() => navigate('/app/stock-report/new')}
								/>
							</ZTooltip>
							<ZTooltip text={ selectedReport == null ? "Please select a report to delete" : selectedReport.isSystem ? "Cannot delete a system report" : "Delete"}>
								<ZButton
                                	className="btn-icon custom-btn-icon"
									disabled={selectedReport == null || selectedReport.isSystem} 
									icon={ZIconType.Delete} 
									size="sm" 
								/>
							</ZTooltip> */}
						</Col>
					</Row>
					<Row className="mb-1" style={{height: "600px"}}>
						<AgGrid 
							ref={gridRef}
							// rowData={report.reports}
							rowData={reportsList.filter(x => x.name.toLowerCase().includes(keyword.toLowerCase()))}
							getRowId={(data: GetRowIdParams<Report, any>) => data.data.id.toString()}
							columnDefs={columns} 
							loading={false}
							rowSelectionType='single'
							onSelectionChanged={(selectedRows) => {
								setSelectedReport(selectedRows && selectedRows.length > 0 ? selectedRows[0] as Report : null);
							}}
							pagination={'clientside'}
						/>
					</Row>
				</Card.Body>
			</Card>
		</>
	);
}